import { InferType } from 'yup';
import { schema } from 'components/GuestDetailsModal/helpers';
import { EditDetailsPopUpActionType, EDIT_DETAILS_POP_UP_ACTION, editDetailsPopUp } from 'lib/gaTracking/bookingDetailsPageEvents';

type FormValuesKey = keyof FormValues;
type ActionMap = { [K in Partial<FormValuesKey>]: EditDetailsPopUpActionType };

export type FormValues = InferType<typeof schema>;

export const trackUpdatedValue = (existingValues: FormValues, updatedValues: FormValues) => {
  const actionMap: Partial<ActionMap> = {
    email: EDIT_DETAILS_POP_UP_ACTION.EMAIL_ADDRESS_UPDATED,
    phone: EDIT_DETAILS_POP_UP_ACTION.PHONE_NUMBER_UPDATED,
    qffNumber: EDIT_DETAILS_POP_UP_ACTION.QFF_UPDATED,
    businessNumber: EDIT_DETAILS_POP_UP_ACTION.ABN_UPDATED,
  };

  Object.keys(existingValues).forEach((key) => {
    const value = key as keyof typeof existingValues;
    const isDirty = existingValues[value] !== updatedValues[value];
    const action = actionMap[value];
    if (isDirty && action) {
      editDetailsPopUp(action);
    }
  });
};

export const trackEditDetailsPopUp = () => editDetailsPopUp(EDIT_DETAILS_POP_UP_ACTION.SAVE_CHANGES_BUTTON_SELECTED);
